module.exports = __webpack_public_path__ + "static/media/hover_image_free.83d5c746.png";